import './index.css';

interface SocialSite {
    href: string;
    font: string;
    colr: string;
    name: string;
}

export const SocialBar: React.FC = () => {
    const social: SocialSite[] = [{
        href: 'https://twitter.com/staratarms',
        font: 'fab fa-twitter',
        colr: '#1DA1F2',
        name: 'Twitter'
    }, {
        href: 'https://www.instagram.com/staratarms',
        font: 'fab fa-instagram',
        colr: '#fb3958',
        name: 'Instagram'
    }, {
        href: 'https://www.linkedin.com/in/alanjfitzpatrick',
        font: 'fab fa-linkedin-in',
        colr: '#0077B5',
        name: 'LinkedIn'
    }, {
        href: 'https://github.com/alajfit',
        font: 'fab fa-github',
        colr: '#333333',
        name: 'GitHub'
    }]

    return (
        <ul className="SocialBar" aria-label='social-bar'>
            {social.map(site=> (
                <li key={site.href}>
                    <a href={site.href} target="_blank" rel="noopener noreferrer" aria-label={site.name}>
                        <i className={site.font} style={{ color: site.colr}}></i>
                    </a>
                </li>
            ))}
        </ul>
    )
}
